// ─── J1 League Data Layer ───────────────────────────────────────────────────
// Live data fetched from Cloudflare Worker (deploy jleague-scraper-worker)
// Falls back to GW8 snapshot if worker is unreachable.

const JLEAGUE_WORKER_URL = 'https://jleague-proxy.footballgirl.workers.dev';

// ── Snapshot: standings as of 19 April 2026 (East & West groups) ────────────
// J1 100 Year Vision League – transitional season (Feb–Jun 2026)
// East group
const J1_EAST_SNAPSHOT = [
  { pos: 1, team: 'Tokyo Verdy',        short: 'TYKV', played: 9, won: 5, drawn: 2, lost: 2, gf: 13, ga: 9,  gd: 4,  pts: 17 },
  { pos: 2, team: 'Urawa Red Diamonds', short: 'URA',  played: 9, won: 5, drawn: 1, lost: 3, gf: 11, ga: 8,  gd: 3,  pts: 16 },
  { pos: 3, team: 'Kashima Antlers',    short: 'KAN',  played: 9, won: 4, drawn: 3, lost: 2, gf: 12, ga: 8,  gd: 4,  pts: 15 },
  { pos: 4, team: 'FC Tokyo',           short: 'FCT',  played: 9, won: 4, drawn: 2, lost: 3, gf: 10, ga: 9,  gd: 1,  pts: 14 },
  { pos: 5, team: 'Machida Zelvia',     short: 'ZEL',  played: 9, won: 4, drawn: 1, lost: 4, gf: 12, ga: 13, gd: -1, pts: 13 },
  { pos: 6, team: 'Kawasaki Frontale',  short: 'KAW',  played: 9, won: 3, drawn: 3, lost: 3, gf: 14, ga: 12, gd: 2,  pts: 12 },
  { pos: 7, team: 'Mito HollyHock',     short: 'MITO', played: 9, won: 3, drawn: 2, lost: 4, gf: 9,  ga: 11, gd: -2, pts: 11 },
  { pos: 8, team: 'JEF United Chiba',   short: 'JEF',  played: 9, won: 3, drawn: 1, lost: 5, gf: 7,  ga: 12, gd: -5, pts: 10 },
  { pos: 9, team: 'Yokohama F. Marinos',short: 'YOK',  played: 9, won: 2, drawn: 3, lost: 4, gf: 10, ga: 13, gd: -3, pts: 9  },
  { pos:10, team: 'Kashiwa Reysol',     short: 'KRE',  played: 9, won: 2, drawn: 0, lost: 7, gf: 9,  ga: 18, gd: -9, pts: 6  },
];

// West group
const J1_WEST_SNAPSHOT = [
  { pos: 1, team: 'Gamba Osaka',        short: 'GAM',  played: 9, won: 5, drawn: 3, lost: 1, gf: 14, ga: 7,  gd: 7,  pts: 18 },
  { pos: 2, team: 'Cerezo Osaka',       short: 'CER',  played: 9, won: 5, drawn: 2, lost: 2, gf: 13, ga: 9,  gd: 4,  pts: 17 },
  { pos: 3, team: 'Sanfrecce Hiroshima',short: 'SAN',  played: 9, won: 5, drawn: 1, lost: 3, gf: 12, ga: 9,  gd: 3,  pts: 16 },
  { pos: 4, team: 'Kyoto Sanga',        short: 'KYO',  played: 9, won: 4, drawn: 2, lost: 3, gf: 11, ga: 9,  gd: 2,  pts: 14 },
  { pos: 5, team: 'Nagoya Grampus',     short: 'NAG',  played: 9, won: 4, drawn: 1, lost: 4, gf: 11, ga: 12, gd: -1, pts: 13 },
  { pos: 6, team: 'Vissel Kobe',        short: 'VIS',  played: 9, won: 3, drawn: 3, lost: 3, gf: 10, ga: 10, gd: 0,  pts: 12 },
  { pos: 7, team: 'Shimizu S-Pulse',    short: 'SHI',  played: 9, won: 3, drawn: 2, lost: 4, gf: 9,  ga: 11, gd: -2, pts: 11 },
  { pos: 8, team: 'V-Varen Nagasaki',   short: 'VVN',  played: 9, won: 3, drawn: 1, lost: 5, gf: 10, ga: 14, gd: -4, pts: 10 },
  { pos: 9, team: 'Fagiano Okayama',    short: 'OKA',  played: 9, won: 2, drawn: 2, lost: 5, gf: 7,  ga: 13, gd: -6, pts: 8  },
  { pos:10, team: 'Avispa Fukuoka',     short: 'AVS',  played: 9, won: 1, drawn: 1, lost: 7, gf: 6,  ga: 16, gd:-10, pts: 4  },
];

// ── Top scorers snapshot ─────────────────────────────────────────────────────
const J1_TOP_SCORERS_SNAPSHOT = [
  { name: 'Deniz Hümmet',       team: 'Mito HollyHock',     goals: 5, assists: 1, nationality: '🇩🇪' },
  { name: 'Erison',             team: 'Cerezo Osaka',        goals: 5, assists: 2, nationality: '🇧🇷' },
  { name: 'Erik',               team: 'Machida Zelvia',      goals: 4, assists: 1, nationality: '🇧🇷' },
  { name: 'Katsuhiro Nakayama', team: 'Gamba Osaka',         goals: 3, assists: 4, nationality: '🇯🇵' },
  { name: 'Leandro Damião',     team: 'Kawasaki Frontale',   goals: 3, assists: 0, nationality: '🇧🇷' },
  { name: 'Ataru Esaka',        team: 'Cerezo Osaka',        goals: 3, assists: 2, nationality: '🇯🇵' },
  { name: 'Koki Morita',        team: 'FC Tokyo',            goals: 2, assists: 4, nationality: '🇯🇵' },
  { name: 'Yuya Osako',         team: 'Vissel Kobe',         goals: 2, assists: 1, nationality: '🇯🇵' },
];

// ── Recent results snapshot ──────────────────────────────────────────────────
const J1_FIXTURES_SNAPSHOT = [
  // Recent results
  { date: 'Apr 19', home: 'Kashima Antlers',   homeScore: 2, awayScore: 1, away: 'Urawa Reds',      status: 'FT',     group: 'East' },
  { date: 'Apr 19', home: 'Gamba Osaka',        homeScore: 1, awayScore: 0, away: 'Cerezo Osaka',    status: 'FT',     group: 'West' },
  { date: 'Apr 19', home: 'Sanfrecce Hiroshima',homeScore: 2, awayScore: 0, away: 'Avispa Fukuoka',  status: 'FT',     group: 'West' },
  { date: 'Apr 13', home: 'Tokyo Verdy',         homeScore: 2, awayScore: 1, away: 'Kawasaki Frontale',status:'FT',    group: 'East' },
  // Upcoming
  { date: 'Apr 22', home: 'Avispa Fukuoka',     homeScore: null, awayScore: null, away: 'Gamba Osaka',   status: 'NS', group: 'West' },
  { date: 'Apr 24', home: 'Kashima Antlers',    homeScore: null, awayScore: null, away: 'Kashiwa Reysol',status: 'NS', group: 'East' },
  { date: 'Apr 25', home: 'Yokohama F. Marinos',homeScore: null, awayScore: null, away: 'Urawa Reds',    status: 'NS', group: 'East' },
  { date: 'Apr 25', home: 'Nagoya Grampus',     homeScore: null, awayScore: null, away: 'Shimizu S-Pulse',status:'NS',  group: 'West' },
];

// ── Live fetch ───────────────────────────────────────────────────────────────
export async function fetchLiveJLeagueData() {
  try {
    const res = await fetch(JLEAGUE_WORKER_URL, { signal: AbortSignal.timeout(6000) });
    if (!res.ok) throw new Error('Worker error');
    const data = await res.json();
    return {
      eastStandings: data.eastStandings ?? J1_EAST_SNAPSHOT,
      westStandings: data.westStandings ?? J1_WEST_SNAPSHOT,
      topScorers:    data.topScorers    ?? J1_TOP_SCORERS_SNAPSHOT,
      fixtures:      data.fixtures      ?? J1_FIXTURES_SNAPSHOT,
      live: true,
    };
  } catch {
    return {
      eastStandings: J1_EAST_SNAPSHOT,
      westStandings: J1_WEST_SNAPSHOT,
      topScorers:    J1_TOP_SCORERS_SNAPSHOT,
      fixtures:      J1_FIXTURES_SNAPSHOT,
      live: false,
    };
  }
}

// Named exports for components that import statically
export const J1_EAST_STANDINGS = J1_EAST_SNAPSHOT;
export const J1_WEST_STANDINGS = J1_WEST_SNAPSHOT;
export const J1_TOP_SCORERS    = J1_TOP_SCORERS_SNAPSHOT;
export const J1_FIXTURES       = J1_FIXTURES_SNAPSHOT;
